// extracted by mini-css-extract-plugin
export default {"body":"NotFound_body__fQxGl","image":"NotFound_image__uwxyJ","notFoundWrapper":"NotFound_notFoundWrapper__9P0dr"};